import {createContext} from "react"

export const ContextAreaContext = createContext(null)
